import { z } from 'zod';

import { dateTimeSchema } from '@apple/utils/globalization/models';

export interface AnnouncementList {
	announcements: Announcement[];
	unreadCount: number;
	totalCount: number;
}

export interface Announcement {
	contentId: number;
	title: string;
	content: string;
	createdDate: Date;
	acknowledged: boolean;
	active: boolean;
}

export const announcementSchema = z.object({
	contentId: z.number(),
	title: z.string(),
	content: z.string(),
	createdDate: dateTimeSchema,
	acknowledged: z.boolean(),
	active: z.boolean(),
}) as z.ZodType<Announcement>;

export const announcementListSchema = z.object({
	announcements: z.array(announcementSchema),
	unreadCount: z.number(),
	totalCount: z.number(),
}) satisfies z.ZodType<AnnouncementList>;
